<template>
	<v-app>
		<v-main>
			<Main/>
			<!-- <div class="caption py-1 px-2" style="position:fixed; top: 0; left: 0;background-color: black;z-index: 9;color: white;" v-if="showDevLabel">
				<div class="d-flex align-center justify-space-between flex-1" style="gap: 10px;">
					<p class="mb-0 font-weight-bold">Panel Desarrollo</p>
					<v-btn
						icon
						x-small
						color="white"
						@click="showDevLabel = false"
					>
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</div>
				<p class="mb-0">09-04-2026</p>
			</div> -->
		</v-main>
	</v-app>
</template>

<script>
import Main from './components/Layout/Main'
import {getRdiByID} from '@/helpers/api/rdi'
import {getTareaByID} from '@/helpers/api/tasks'
import { getMeeting } from '@/helpers/api/meetings'

export default {
	name: 'App',
	components: {
		Main,
	},
	computed: {
		userAuth() {
			return this.$store.userStore.state.isAuthenticated
		},
		selectedProject(){
			return this.$store.projectsStore.state.selectedProject
		},
		queryParams(){
			return this.$route.query
		}
	},
	watch: {
		queryParams(){
			this.checkLink()
		},
		userAuth(newData, oldData) {
			if(newData && !oldData){
				this.getUserInfo()
				this.getSelectedProject()
				this.getReminders()
				this.getSystemCurrencies()
			}
		},
		selectedProject(newData, oldData){
			if(newData && newData !== oldData){
				if(this.selectedProject){
					this.getNotifications()
				}
			}
		}
	},
	data: () => ({
		showDevLabel: true
	}),
	mounted(){
		this.setCloseListener()
		this.$store.menuStore.commit('setMenuSidebarStatus', !this.$vuetify.breakpoint.mobile)
		if(this.$store.userStore.state.isAuthenticated){
			this.getUserInfo()
			this.getSelectedProject()
			this.getReminders()
			this.getSystemCurrencies()
		}
		if(this.selectedProject){
			this.getNotifications()
		}
	},
	methods: {
		setCloseListener(){
			window.onbeforeunload = function (e) {
				if( Object.keys(this.$store && this.$store.globalStore.state.filesToUploadCenter).length > 0 ){
					e = e || window.event
					if (e) { e.returnValue = 'Sure?' }
					return 'Sure?'
				}
			};
		},
		checkLink(){
			if(this.$route.query.rdi){
				const query = {...this.$route.query}
				this.$router.replace({name: this.$route.name})
				this.viewRDI(query.rdi, false)
			}
			if(this.$route.query.task){
				const query = {...this.$route.query}
				this.$router.replace({name: this.$route.name})
				this.viewTarea(query.task, false)
			}
			if(this.$route.query.additional){
				const query = {...this.$route.query}
				this.$router.replace({name: this.$route.name})
				this.viewAdditional(query.additional, false)
			}
			if(this.$route.query.meeting){
				const query = {...this.$route.query}
				this.$router.replace({name: this.$route.name})
				this.viewMeeting(query.meeting)
			}
		},
		getSystemCurrencies(){
			this.$store.generalStore.dispatch('getSystemCurrencies')
		},
		getUserInfo(){
			this.$store.userStore.dispatch('getUserInfo')
		},
		async getSelectedProject(){
			await this.$store.projectsStore.dispatch('getSelectedProject')
			let companyID = null
			if(this.$store.projectsStore.state.selectedProject){
				companyID = this.$store.projectsStore.state.selectedProject.company_id
				this.getDashboardInfo()
				this.getProjectUserList()
			}
			this.setCompanyPermissions(companyID)
		},
		setCompanyPermissions(companyID){
			if(this.$store.userStore.state.userCompanies.length > 0){
				let companyInfo = null
				if(companyID){
					companyInfo = this.$store.userStore.state.userCompanies.find((company) => {
						return company.company_id = companyID
					})
				}
				else{
					companyInfo = this.$store.userStore.state.userCompanies[0]
				}
				this.$store.userStore.commit('setCompanyPermissions', companyInfo.capabilities)
				this.$store.userStore.commit('setSelectedCompany', companyInfo)
			}
		},
		getDashboardInfo(){
			this.$store.projectsStore.dispatch('getDashboardInfo')
			this.$store.fileManagerStore.dispatch('getProjectStorageSize', {
				project_id: this.$store.projectsStore.state.selectedProject.id
			})
		},
		getNotifications(){
			this.$store.notificationsStore.dispatch('getNotifications')
			if(this.selectedProject.id){
				this.$store.notificationsStore.dispatch('getEmailNotificationsOptions', {
					project_id: this.selectedProject.id
				})
			}
		},
		getReminders(){
			this.$store.notificationsStore.dispatch('getReminders')
		},
		getProjectUserList(){
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				start: 0,
				limit: 20
			}
			this.$store.usersStore.dispatch('getUsersList', data)
		},
		async viewRDI(rdi_id, seen_by_me){
			this.$store.rdiStore.commit('setCurrentRDI', {loading: true})
			const rdi = await getRdiByID({rdi_id})
			if(rdi.code === 200){
				let rdiData = rdi.rdi
				rdiData.prev_seen_by_me = seen_by_me
				this.$store.rdiStore.commit('setCurrentRDI', rdiData)
			}
			else if(rdi.code === 403){
				this.$store.rdiStore.commit('setCurrentRDI', null)
				const data = {
					message: rdi.message,
					title: 'Error',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#F4516C'
				}
				this.$store.globalStore.dispatch('addMessage', data)
			}
		},
		async viewTarea(task_id, seen_by_me){
			this.$store.consultasStore.commit('setCurrentTarea', {loading: true})
			const tarea = await getTareaByID({task_id})
			if(tarea.code === 200){
				let tareaData = tarea.task
				tareaData.prev_seen_by_me = seen_by_me
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		async viewAdditional(additional_id, seen_by_me){
			this.$store.adicionalesStore.dispatch('getAdditionalByID', {additional_id, seen_by_me})
		},
    async viewMeeting(meeting_id, seen_by_me) {
      this.$store.meetingStore.commit('setCurrentMeeting', { loading: true })
      const response = await getMeeting({ meeting_id })
      if (response.code === 200) {
        const meetingData = response.meeting
        meetingData.prev_seen_by_me = seen_by_me
        this.$store.meetingStore.commit('setCurrentMeeting', meetingData)
			} else if (response.code === 403) {
				this.$store.meetingStore.commit('setCurrentMeeting', null)
				this.$store.globalStore.dispatch('addMessage', {
					message: response.message,
					title: 'Error',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#F4516C'
				})
      }
    },
	}
};
</script>

<style>
	body{
		margin: 0;
		overflow: auto;
    overflow-x: hidden;
	}
	.custom-text-field-minify{
		font-size: 12px;
	}
	.custom-text-field-minify .v-input__control,
	.custom-text-field-minify .v-field__input,
	.custom-text-field-minify .v-input__slot,
	.custom-text-field-minify .v-select__slot,
	.custom-select-uf .v-select__selections {
		height: 30px!important;
		min-height: 30px!important;
	}
	.custom-text-field-minify .v-input__append-inner{
		margin-top: 3px!important;
	}
</style>